<template>
  <!--  -->
  <div id="app" class="flex flex-row bg-gray-100" :style="loadingpage ? 'background-color: #fff;' : ''">
    <!--  -->
    <Login v-if="!login"> </Login>
    <!--  -->
    
    <!--  -->
    <template v-if="accountIsComplete">
      <!--  -->
      <side-bar v-if="login && user && user.content.status == 'active' && $route.name != 'createStore'" :idWharhouse="idWharhouse" :user="user.content"></side-bar>
      <!--  -->
    </template>
    <!--  -->
    
    <!--  -->
    <main v-if="login" :class="!ShowSidebar() || resize() ? 'mll-0' : ''" class="flex flex-col flex-auto w-full min-w-0">
      <!--  -->
      <top-bar v-if="$route.name != 'createStore'" :typeUser="typeUser" class="sticky top-0"></top-bar>
      <!--  -->

      <!--  -->
      <vue-ins-progress-bar></vue-ins-progress-bar>
      <!--  -->

      <!--  -->
      <router-view />
      <!--  -->

      <!--  -->
      <div v-if="$route.name != 'createStore'" class="mt-10 flex flex-0 items-center justify-center w-full h-14 px-4 md:px-6  border-t bg-card dark:bg-transparent">
        <!--  -->
        <span class="text-sm md:text-base font-medium text-secondary">vex © {{ new Date().getFullYear() }}</span>
        <!--  -->
      </div>
      <!--  -->
    </main>
    <!--  -->
    
    <!--  -->
    <div v-if="loadingpage" id="loadingpage">
      <!--  -->
      <div class="loader loader-mixed">
        <!--  -->
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:svgjs="http://svgjs.com/svgjs" xmlns:xlink="http://www.w3.org/1999/xlink" width="120" height="120">
          <!--  -->
          <svg xmlns="http://www.w3.org/2000/svg" class="lds-microsoft" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100" style="background:0 0" width="120" height="120">
            <!--  -->
            <g class="color000 svgShape">
              <!--  -->
              <circle cx="73.801" cy="68.263" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(125.399 50 50)">
                <!--  -->
                <animateTransform attributeName="transform" begin="0s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50" />
                <!--  -->
              </circle>
              <!--  -->

              <!--  -->
              <circle cx="68.263" cy="73.801" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(153.871 50 50)">
                <!--  -->
                <animateTransform attributeName="transform" begin="-0.062s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50" />
                <!--  -->
              </circle>
              <!--  -->

              <!--  -->
              <circle cx="61.481" cy="77.716" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(182.969 50 50)">
                <!--  -->
                <animateTransform attributeName="transform" begin="-0.125s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50" />
                <!--  -->
              </circle>
              <!--  -->

              <!--  -->
              <circle cx="53.916" cy="79.743" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(213.399 50 50)">
                <!--  -->
                <animateTransform attributeName="transform" begin="-0.187s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50" />
                <!--  -->
              </circle>
              <!--  -->

              <!--  -->
              <circle cx="46.084" cy="79.743" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(241.838 50 50)">
                <!--  -->
                <animateTransform attributeName="transform" begin="-0.25s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50" />
                <!--  -->
              </circle>
              <!--  -->

              <!--  -->
              <circle cx="38.519" cy="77.716" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(267.328 50 50)">
                <!--  -->
                <animateTransform attributeName="transform" begin="-0.312s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50" />
                <!--  -->
              </circle>
              <!--  -->

              <!--  -->
              <circle cx="31.737" cy="73.801" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(289.993 50 50)">
                <!--  -->
                <animateTransform attributeName="transform" begin="-0.375s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50" />
                <!--  -->
              </circle>
              <!--  -->

              <!--  -->
              <circle cx="26.199" cy="68.263" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(308.811 50 50)">
                <!--  -->
                <animateTransform attributeName="transform" begin="-0.437s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50" />
                <!--  -->
              </circle>
              <!--  -->

              <!--  -->
              <animateTransform attributeName="transform" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;0 50 50" />
              <!--  -->
            </g>
            <!--  -->
          </svg>
          <!--  -->
        </svg>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="loading-info">Loading vex  ...</div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      login: false,
      loading: false,
      user: { content: {} },
      typeUser: '',
      loadingpage: false,
      idWharhouse: null,
    };
  },
  computed: {
    ...mapGetters([ 'accountIsComplete' ])
  },
  watch: {
    '$store.state.loading': async function (oldVal) {
      this.loadingpage = oldVal;
    },
    '$store.state.wharhouse.warhouseSelected': {
      async handler(newValue) {
        await this.getwharhouseId(newValue.country || newValue);
      },
      deep: true,
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);

    if (document.readyState == 'loading') {
      this.loadingpage = true;
    }

    let vm = this;
    document.addEventListener('readystatechange', function (ev) {
      if (document.readyState == 'complete') {
        setTimeout(function () {
          vm.loadingpage = false;
        }, 800);
      }
    });
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  async mounted() {
    await this.getAccess();
    if (!this.accountIsComplete) {
      this.$router.push('/profil');
    }

    document.onreadystatechange = event => {
      if (document.readyState == 'complete') {
        this.loadingpage = false;
      }
    };
  },
  methods: {
    handleScroll() {
      this.$store.dispatch('setCurrentScrollY', window.scrollY);
    },
    async getwharhouseId(country) {
      const resW = await this.$server.get('warehouses', { country: country });
      if (resW && resW.content) {
        this.idWharhouse = resW.content;
      }
    },
    ShowSidebar() {
      return this.$store.getters.ShowSidebar;
    },
    resize() {
      return this.$store.getters.resize;
    },
    async getAccess() {
      this.loading = false;
      const tokenExist = this.$jwtService.verifyToken();

      if (tokenExist) {
        this.user = await this.$me;

        if (this.user && this.user.status == 200) {
          this.typeUser = this.user.content.type;

          this.$store.commit('setAuthenticatedUser', this.user.content);

          const resW = await this.$server.get('warehouses', {
            country: this.$store.state.wharhouse.warhouseSelected,
          });

          if (resW && resW.content) {
            this.idWharhouse = resW.content;
          }

          this.login = true;
        }
      }
      this.loading = true;
    },
  },
};
</script>

<style>
.maylerz {
  background: linear-gradient(90deg, #ba00df54 0%, #d400df0d 100%);
}

.speedship {
  background: linear-gradient(90deg, #001edf54 0%, #0086df0d 100%);
}

.althiqua {
  background: linear-gradient(90deg, #dfbe0054 0%, #dfbe000d 100%);
}

.cathedis {
  background: linear-gradient(90deg, #df000054 0%, #df0000a4 100%);
}

.ozon {
  background: linear-gradient(90deg, #00df6854 0%, #21df00a4 100%);
}

.ameex {
  background: linear-gradient(90deg, #4700df54 0%, #2900dfa4 100%);
}

.mb-130 {
  margin-bottom: 130px;
}

.maylerz .courier,
.maylerz_seller .courier {
  background-image: url(https://static.wixstatic.com/media/28da16_e1e4d20e61e544fd84c0af67c90063c0~mv2.png/v1/fill/w_130);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 90%;
  width: 130px;
}

.mb-90 {
  margin-bottom: 90px;
}

.min-h-300 {
  min-height: 300px;
}

.WAITING {
  background: linear-gradient(90deg,
      rgb(225 121 16) 0%,
      rgb(240 90 81 / 0%) 100%);
}

.SEND {
  background: linear-gradient(90deg,
      rgb(108 225 16) 0%,
      rgb(240 90 81 / 0%) 100%);
}

.DUP {
  background: linear-gradient(90deg,
      rgb(132 52 220) 0%,
      rgb(240 90 81 / 0%) 100%);
}

.st-STOREINO {
  background-image: url(https://storeno.b-cdn.net/stores/9-2024/1725969524785.png?height=120);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.st-STOREINO div {
  display: none;
}

.STOREINO {
  background: linear-gradient(90deg,
      rgb(92 155 254 / 34%),
      rgb(115 182 254 / 7%));
}



.EDCO {
  background: linear-gradient(90deg, #259b4c, rgb(115 182 254 / 7%));
}

.SHIPSEN {
  background: linear-gradient(90deg, #3182cf, rgb(115 182 254 / 7%));
}

.div-filters .mx-input {
  box-shadow: none;
  border: none;
}

.w-full-imp {
  width: 100% !important;
}

.ant-row input:focus-visible+.ant-input-group-addon {
  outline: 2px solid rgb(72, 156, 248);
}

.ant-row {
  position: relative;
  height: auto;
  padding: 0;
  color: #4d4d4d;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  margin-bottom: 24px;
  zoom: 1;
  display: block;
  box-sizing: border-box;
  cursor: pointer;
}

.ant-label {
  display: inline-block;
  overflow: hidden;
  line-height: 39.9999px;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}

.ant-col {
  position: relative;
  min-height: 1px;
}

.ant-row label {
  position: relative;
}

.ant-label>label {
  color: rgba(0, 0, 0, 0.85);
}

.ant-form-item-control {
  position: relative;
  line-height: 40px;
  zoom: 1;
}

.ant-form-item-children {
  position: relative;
}

.ant-input-group-wrapper {
  display: inline-block;
  width: 100%;
  text-align: start;
  vertical-align: top;
}

.ant-input-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #4d4d4d;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.ant-input[disabled] {
  background: rgb(247, 249, 250);
}

.ant-input-group>.ant-input:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input {
  height: 40px;
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
  touch-action: manipulation;
  -webkit-appearance: none;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  padding: 4px 11px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
  font-size: 14px;
  line-height: 1.5;
  border-collapse: separate;
  border-spacing: 0;
}

.ant-input-group-addon:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}

.ant-input-group-addon {
  position: relative;
  padding: 0 11px;
  color: #4d4d4d;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
}

.ant-input-group-addon,
.ant-input-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}

.ant-input-group-addon,
.ant-input-group-wrap,
.ant-input-group>.ant-input {
  display: table-cell;
}

.svg-inline--fa.fa-w-14 {
  width: 0.875em;
}

.hahmov {
  font-size: 20px;
  color: rgb(92, 97, 102);
  margin-right: 0px;
}

.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
  fill: currentColor;
}

.ant-input-group>.ant-input {
  display: table-cell;
}

.ant-input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  opacity: 1;
}

#vm2_box_ModalChangeStatus .vm2_body {
  max-height: 400px;
}

#vm2_box_ModalChangeStatus .s-sidebarwidget {
  margin-bottom: 80px;
}

.error {
  color: #c62525;
}

.success {
  color: #25c631;
}

.chrono_diali {
  background: linear-gradient(90deg, #009adf54 0%, #009adf0d 100%);
}

.chrono_diali_seller {
  background: linear-gradient(90deg, #38da84 0%, #43e89100 100%);
}

.chrono_diali .courier,
.chrono_diali_seller .courier {
  background-image: url(https://storeno.b-cdn.net/edco/11-2022/1668192140243.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 90%;
  width: 130px;
}

.maylerz .courier div,
.speedship .courier div,
.althiqua .courier div,
.cathedis .courier div,
.ozon .courier div,
.ameex .courier div,
.chrono_diali .courier div,
.digylog .courier div,
.aramex .courier div,
.rushliv .courier div,
.st_edco .courier div {
  display: none;
}

.st_edco {
  background: linear-gradient(90deg,
      rgb(56, 161, 105),
      rgba(189, 234, 210, 0.8)) !important;
}

.st_edco .courier {
  background-image: url(https://storeno.b-cdn.net/fastgo/10-2023/1697549038355.png) !important;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 30%;
  width: 115px !important;
}

.digylog {
  background: linear-gradient(90deg, #f3911e85 0%, #f3911e24 100%);
}

.aramex {
  background: linear-gradient(90deg,
      rgb(241 88 79) 0%,
      rgb(240 90 81 / 0%) 100%);
}

.rushliv {
  background: linear-gradient(90deg,
      rgb(227, 79, 241) 0%,
      rgba(227, 81, 240, 0) 100%);
}

.rushliv .courier {
  background-image: url('https://cdn.rushliv.com/images/company/logo-header-menu.png');
  /* The image used */
  background-position: center;
  /* Center the image */
  background-repeat: no-repeat;
  /* Do not repeat the image */
  background-size: 70%;
  width: 130px;
}

.digylog .courier {
  background-image: url('https://storeno.b-cdn.net/edco/11-2022/1668194728662.png');
  /* The image used */
  background-position: center;
  /* Center the image */
  background-repeat: no-repeat;
  /* Do not repeat the image */
  background-size: 70%;
  width: 130px;
}

.aramex .courier {
  background-image: url('https://storeno.b-cdn.net/edco/3-2023/1678458827905.png');
  /* The image used */
  background-position: center;
  /* Center the image */
  background-repeat: no-repeat;
  /* Do not repeat the image */
  background-size: 70%;
  width: 130px;
}

.orange-orders{
  background: linear-gradient(to right, #f97316, #fed7aa);
}

.orange-orders:hover {
  background-color: #fb923c;
}

#spinner22 {
  display: inline-block;
}

#spinner22 .path-solid {
  stroke: #0f0f0f;
}

.v-select ::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #8c8d8e;
}

.mb-13 {
  margin-bottom: 4rem;
}

.mb-14 {
  margin-bottom: 5rem;
}

.box-2 {
  flex-grow: 1;
  flex-direction: colum;
  display: flex;
}

.box-3 {
  flex: 1 1 auto;
  min-height: 1px;
}

.v-select :-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #8c8d8e;
  opacity: 1;
}

.v-select ::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #8c8d8e;
  opacity: 1;
}

.v-select :-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #8c8d8e;
}

.v-select ::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #8c8d8e;
}

.v-select ::placeholder {
  /* Most modern browsers support this now. */
  color: #8c8d8e;
}

.rounded-full-s {
  border-radius: 100%;
}

.badge-light-primary {
  color: #723aeb;
  background-color: #f8f5ff;
  display: flex;
  align-items: center;
  font-size: 11px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 1rem;
  padding-left: 1rem;
  --bs-badge-padding-x: 0.5rem;
  --bs-badge-padding-y: 0.325rem;
  --bs-badge-font-size: 0.85rem;
  --bs-badge-font-weight: 600;
  --bs-badge-color: #ffffff;
  --bs-badge-border-radius: 0.425rem;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 4px;
}

.badge-light-danger {
  color: #f2416c;
  background-color: #fff5f8;
  display: flex;
  align-items: center;
  font-size: 11px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 1rem;
  padding-left: 1rem;
  --bs-badge-padding-x: 0.5rem;
  --bs-badge-padding-y: 0.325rem;
  --bs-badge-font-size: 0.85rem;
  --bs-badge-font-weight: 600;
  --bs-badge-color: #ffffff;
  --bs-badge-border-radius: 0.425rem;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 4px;
}

.pulse {
  display: block;
  margin-right: 4px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ffb209;
  cursor: pointer;
  box-shadow: 0 0 0 rgba(255, 178, 9, 0.9);
  animation: pulse 2s infinite;
}

.sous-s {
  color: #646878;
  background-color: #e2e8f0;
  font-weight: 500;
  align-items: center;
  margin-top: 4px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 5px;
  --bs-badge-padding-x: 0.5rem;
  --bs-badge-padding-y: 0.325rem;
  --bs-badge-font-size: 0.85rem;
  --bs-badge-font-weight: 600;
  --bs-badge-color: #ffffff;
  --bs-badge-border-radius: 0.425rem;
  padding: 2px 6px;
  font-size: 10px;
}

.text-www {
  color: #ffb209;
  font-size: 10px;
}

.pulse:hover {
  animation: none;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 178, 9, 0.9);
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(255, 178, 9, 0);
  }

  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 178, 9, 0);
  }
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 178, 9, 0.9);
    box-shadow: 0 0 0 0 rgba(255, 178, 9, 0.7);
  }

  70% {
    -moz-box-shadow: 0 0 0 10px rgba(255, 178, 9, 0);
    box-shadow: 0 0 0 10px rgba(255, 178, 9, 0);
  }

  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 178, 9, 0);
    box-shadow: 0 0 0 0 rgba(255, 178, 9, 0);
  }
}

.tab-datas .vm2__close,
#vm2_box_ModalPay .vm2__close,
#vm2_box_ModalRefunds .vm2__close,
#vm2_box_toShipp .vm2__close,#vm2_box_modalConfirm .vm2__close {
  display: none;

}

.tab-trr svg {
  width: 35px;
}

.loading-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 16em;
  min-height: 8.75em;
  margin-top: -4.3em;
  margin-left: -8em;
  font-size: 14px;
  animation: zoom 0.3s 1 linear, fadein 0.5s 1 linear;
}

#loadingpage {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.97;
  background-color: #fff;
  z-index: 10000;
}

#loadingpage .loader {
  position: absolute;
  z-index: 30;
  left: 50%;
  width: 120px;
  margin-left: -65px;
  margin-bottom: 30px;
}

#loadingpage .loader .spinner-ball-outer,
.ecwid-loadingIndicator .loader .spinner-ball-outer {
  width: 88px;
  height: 88px;
  background: transparent url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='88' viewBox='0 0 88 88'%3E%3Cpath fill='none' stroke='%23275ce0' stroke-linecap='round' stroke-width='3' d='M64.8 79.5C58.4 83.3 51 85.5 43 85.5 27 85.5 13 76.6 5.8 63.5M64.4 6.2C77 13.6 85.5 27.3 85.5 43 85.5 50.7 83.4 58 79.8 64.2M.5 43C.5 19.5 19.5.5 43 .5' transform='translate(1 1)'/%3E%3C/svg%3E") center center no-repeat;
  background-size: contain;
  animation: spinright 0.8s infinite linear;
}

#loadingpage .loader .spinner-ball-inner,
.ecwid-loadingIndicator .loader .spinner-ball-inner {
  width: 40px;
  height: 40px;
  margin: -64px auto 64px;
  background: transparent url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'%3E%3Cpath fill='%23275ce0' d='M20 39.5C9.2 39.5.5 30.8.5 20S9.2.5 20 .5 39.5 9.2 39.5 20c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5c0-9.1-7.4-16.5-16.5-16.5S3.5 10.9 3.5 20 10.9 36.5 20 36.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z'/%3E%3C/svg%3E") center center no-repeat;
  background-size: contain;
  animation: spinleft 0.5s infinite linear;
}

#loadingpage .loading-info {
  position: absolute;
  width: 100%;
  margin-top: 6em;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #0a1c2e;
}

@keyframes spinleft {
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

@keyframes spinright {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

[class*='toggle__dot-'] {
  top: -0.25rem;
  left: -0.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked~[class*='toggle__dot-'] {
  transform: translateX(100%);
  background-color: #63b3ed;
}

.input-style {
  padding: 0.375rem 0.75rem;
  font-size: 0.9375rem;
  line-height: 1.6;
  color: #9493a9 !important;
  background-color: #f4f3f9;
  background-clip: padding-box;
  border: 1px solid #e1e0ea;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 3px;
}

@keyframes blinkdot {
  0% {
    opacity: 0.2;
  }

  20% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
}

.loading-excel span {
  animation-name: blinkdot;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  font-weight: 900;
  vertical-align: text-bottom;
}

.loading-excel span:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-excel span:nth-child(3) {
  animation-delay: 0.4s;
}

.dot-carousel {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #f4f3fb;
  color: #f4f3fb;
  box-shadow: 9984px 0 0 0 #f4f3fb, 9999px 0 0 0 #f4f3fb, 10014px 0 0 0 #f4f3fb;
  animation: dotCarousel 1.5s infinite linear;
  margin-left: 20px;
  margin-right: 14px;
}

@keyframes dotCarousel {
  0% {
    box-shadow: 9984px 0 0 -1px #f4f3fb, 9999px 0 0 1px #f4f3fb,
      10014px 0 0 -1px #f4f3fb;
  }

  50% {
    box-shadow: 10014px 0 0 -1px #f4f3fb, 9984px 0 0 -1px #f4f3fb,
      9999px 0 0 1px #f4f3fb;
  }

  100% {
    box-shadow: 9999px 0 0 1px #f4f3fb, 10014px 0 0 -1px #f4f3fb,
      9984px 0 0 -1px #f4f3fb;
  }
}

.v-select .vs__selected {
  white-space: nowrap !important;
}

.v-select .vs__dropdown-toggle {
  overflow-x: hidden !important;
}

.vs__selected-options {
  flex-wrap: inherit;
}

body {
  position: relative;
}

.width-90 {
  width: 90%;
}

.width-10 {
  width: 10%;
}

.warehouse .vs__search {
  z-index: 0 !important;
  color: #909192;
}

.dashbord img {
  width: 200x;
}

.link:hover {
  background-color: white;
  color: #805ad5;
  border-radius: 6px;
  /* font-weight: bold; */
}

.img-link img:last-child {
  display: none;
}

.link:hover img:last-child {
  display: block;
}

.link:hover img:first-child {
  display: none;
}

.vertical-navigation-mode-over {
  position: fixed !important;
  transform: translateZ(0);
  left: 0 !important;
  top: 0 !important;
  bottom: 0;
}

#nav {
  transition-duration: 0.4s;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-property: visibility, margin-left, margin-right, transform, width,
  max-width, min-width;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  background-color: #fc3801;
  position: sticky;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  top: 0;
  width: 260px;
  min-width: 260px;
  max-width: 260px;
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  z-index: 10;
}

@media (max-width: 768px) {
  #nav {
    width: 300px;
    min-width: 300px;
    max-width: 300px;
  }
}

.jvectormap-tip {
  padding: 3px 6px 3px;
  font-size: 10px;
  border-radius: 50px;
  text-transform: capitalize;
  font-weight: 400;
  display: block;
  margin-top: 4px;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
}

.label-danger {
  background: #ea6c41;
}

.label-success {
  background: #469408;
}

.label-warning {
  background: #e69a2a;
}

.percent__int {
  font-size: 15px !important;
}

.percent .percent__dec,
.percent .dot {
  display: none;
}

.vue-circular-progress .circle__progress--path {
  stroke-opacity: 0.2 !important;
}

.s-sidebarwidget__yellow {
  border-color: hsl(47deg 65% 84%);
  background-color: hsl(47deg 87% 94%);
}

.sidebarwidget__yellow .s-sidebarwidget--header,
.s-sidebarwidget__yellow .s-sidebarwidget--content {
  border-color: hsl(47deg 65% 84%);
}

.s-sidebarwidget--header.s-sidebarwidget__small-bold-text {
  font-size: 14px;
  font-weight: bold;
}

.s-sidebarwidget--header:first-child {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.s-sidebarwidget__yellow .s-sidebarwidget--header {
  background-color: #fbf3d5;
  color: #6b737c;
}

.s-sidebarwidget--item {
  margin: 12px 0;
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.fc-light {
  color: hsl(210deg 7% 44%) !important;
}

.bbw1 {
  border-bottom-width: 1px !important;
}

.bb {
  border-bottom-style: solid !important;
  border-bottom-width: 1px !important;
}

.s-sidebarwidget--header {
  padding: 12px 15px;
  background: hsl(0deg 0% 98%);
}

.s-sidebarwidget--header,
.s-sidebarwidget--content {
  border-top: 1px solid hsl(210deg 7% 89%);
}

.s-sidebarwidget {
  position: relative;
  border: 1px solid hsl(210deg 8% 85%);
  border-radius: 3px;
  font-size: 13px;
}

.loidingconfirm svg {
  width: 30px;
}

.noselect {
  pointer-events: none;
}

.seller-select .vs__dropdown-toggle {
  border: none;
}

.vs__dropdown-toggle {
  border: none;
}

.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #eef1f6;
  border-color: #d1dbe5;
}

.disabled-loading {
  pointer-events: none;
  cursor: not-allowed;
}

.vm2_body .ins-progress {
  position: absolute !important;
}

.h-14 {
  height: 3.5rem !important;
}

.modal-footer {
  overflow: auto;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
  border-top: 1px solid #ededed;
  padding-top: 15px;
  padding-bottom: 15px;
}

.mb-13 {
  margin-bottom: 4rem;
}

.mll-0 {
  margin-left: 0 !important;
}

.vm2__header h4 {
  pointer-events: none;
}

.vm2__header h4,
.vm2__header .vm2__close {
  font-weight: 600;
}

.vm2_wrapper {
  z-index: 1000;
}

.vm2_body {
  max-height: 500px;
}

.hover\:bg-indigo-darker:hover {
  background-color: #2f365f;
}

.bg-indigo-darker {
  background-color: #2f365f;
}

.bg-indigo {
  background-color: #6574cd;
}

.hover\:bg-indigo:hover {
  background-color: #6574cd;
}

.box-1 {
  background: #f2f4f7;
  border: 2px solid #77d8c8;
  border-radius: 0.375rem;
}

.text-smmm {
  font-size: 9px;
}

.flag-img {
  display: inline-block;
  height: 16px;
  width: 16px;
  vertical-align: text-top;
  line-height: 16px;
  margin-right: 5px;
}

.form-checkbox {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  flex-shrink: 0;
  color: currentColor;
  background-color: #fff;
  border-color: #e2e8f0;
  border-width: 1px;
  border-radius: 0.25rem;
  height: 1.2em;
  width: 1.2em;
}

.form-checkbox:checked {
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.alert-dialog {
  position: fixed;
  transform: translate(-50%, -50%);
  z-index: 9990;
  padding: 15px 25px;
  color: #444444;
  background-color: white;
  box-shadow: 0 15px 30px 5px #00000045;
  border-radius: 35px;
  cursor: pointer;
}

.alert-dialog.fadein {
  animation: fadein 1s;
}

.alert-dialog.fadeout {
  animation: fadeout 1s;
}

@keyframes fadein {
  0% {
    opacity: 0;
    transform: translate(-50%, 50%);
  }

  100% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }

  100% {
    opacity: 0;
    transform: translate(-50%, 50%);
  }
}

.intro-y {
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation 0.4s ease-in-out 0.33333s;
  animation: intro-y-animation 0.4s ease-in-out 0.33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.zoom-in:hover {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.043137254901960784);
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
}

.zoom-in {
  cursor: pointer;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-property: background-color, border-color, color, fill, stroke,
    opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke,
    opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke,
    opacity, box-shadow, transform, filter, backdrop-filter,
    -webkit-backdrop-filter;
  transition-duration: 0.15s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.3s;
}

.box {
  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.043137254901960784);
  background-color: #fff;
  border-radius: 0.375rem;
}

.c-warning {
  color: #d7841c;
}

.bg-ww {
  border: 2px solid #77d7c8;
  background-color: #f5f5f5;
  padding: 15px;
  max-height: 270px;
  overflow-y: auto;
}

.bg-ww::-webkit-scrollbar {
  background-color: #fff;
  width: 16px;
}

.bg-ww::-webkit-scrollbar-track:hover {
  background-color: #f4f4f4;
}

/* scrollbar itself */
.bg-ww::-webkit-scrollbar-thumb {
  background-color: #babac0;
  border-radius: 16px;
  border: 5px solid #fff;
}

.bg-ww::-webkit-scrollbar-thumb:hover {
  background-color: #a0a0a5;
  border: 4px solid #f4f4f4;
}

#vm2_box_Refund .vm2__close {
  display: none !important;
}

#vm2_box_Refund {
  background-color: #f2f2f2 !important;
}

.bg-ww::-webkit-scrollbar-button {
  display: none;
}

.data-ss {
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1), 0 0 1px 0 rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  line-height: 1.28;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  box-sizing: border-box;
  position: relative;
  padding: 15px;
  overflow-x: auto;
  overflow-y: auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}

.row-data {
  margin-bottom: 8px;
  margin-top: 5px;
}

.row-data .title-1 {
  font-weight: 400;
  word-wrap: normal;
  color: rgba(0, 0, 0, 0.85);
  white-space: inherit;
  font-size: 0.875rem !important;
}

.row-data .content-1 {
  text-align: left;
  color: rgba(0, 0, 0, 0.75);
  font-weight: 700;
  word-wrap: normal;
  font-size: 0.875rem !important;
}

.header-1 {
  width: 100%;
  font-size: 12px;
  line-height: 1.28;
}

.header-1 .content {
  box-sizing: border-box;
  height: 60px;
}

.header-1 .title {
  white-space: nowrap;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  text-align: left;
  text-overflow: ellipsis;
  color: rgba(0, 0, 0, 0.75);
  font-weight: 700;
  font-size: 1.125rem !important;
  line-height: 1.33334 !important;
}

.header-1 .content-1 {
  white-space: nowrap;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  font-weight: normal;
  text-overflow: ellipsis;
  color: rgba(0, 0, 0, 0.75);
  word-wrap: normal;
  line-height: 1.42858 !important;
  font-size: 0.875rem !important;
}

.header-table {
  width: 100%;
  display: flex;
  align-items: center;
  height: 48px;
  box-sizing: border-box;
  padding-top: 10px;
  padding-bottom: 10px;
  box-shadow: inset 0 -1px 0 #dadcde;
  border-top: 1px solid #cecdcd;
}

.header-table .title {
  display: flex;
  align-items: center;
  min-width: 0;
  text-align: left;
  color: rgba(0, 0, 0, 0.75);
  font-weight: 700;
  word-wrap: normal;
  line-height: 1.42858;
  white-space: inherit;
  font-size: 0.875rem;
}

.header-table .title-1 {
  font-weight: 400 !important;
}

.xz84dc7 {
  width: 60%;
}

.x8yj6t5 {
  width: 20%;
}

.x8yj6t5 {
  width: 20%;
}

.loading-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 16em;
  min-height: 8.75em;
  margin-top: -4.3em;
  margin-left: -8em;
  font-size: 14px;
  animation: zoom 0.3s 1 linear, fadein 0.5s 1 linear;
}

.ml-auto-imp {
  margin-left: auto !important;
}

.check {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
}

.check-left {
  position: absolute;
  top: 5px;
  left: 5px;
}

.active .check-left {
  display: block;
}

i.tiny {
  font-size: 12px;
  line-height: 20px;
}

.feather-icon {
  display: inline-flex;
  align-items: center;
}

.active .check {
  display: block;
}

.intro-y.active {
  border: 2px solid rgb(14 14 14 / 90%);
  background: rgba(103, 240, 114, 0.1);
  border-style: dashed;
}

.warehouse .zoom-in:hover {
  margin-left: 8px;
  margin-right: 8px;
}

/*  Mobile css */
.mat-icon-button {
  padding: 0;
  min-width: 0;
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  border-radius: 50%;
  box-sizing: border-box;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  outline: none;
  border: none;
  -webkit-tap-highlight-color: transparent;
  display: inline-block;
  white-space: nowrap;
  text-decoration: none;
  vertical-align: baseline;
  text-align: center;
  margin: 0;
  overflow: visible;
}

.tinytabs {
  margin-top: 10px;
}

.tinytabs .section .title {
  display: none;
}

.tinytabs .tabs {
  margin-left: 15px;
  display: flex;
  flex-flow: row wrap;
}

.tinytabs .tabs .tab .close {
  padding-left: 5px;
}

.tinytabs .tabs .tab {
  margin: 0 3px 0 0;
  background: #e1e1e1;
  display: block;
  padding: 6px 15px;
  text-decoration: none;
  color: #666;
  font-weight: bold;
  border-radius: 3px 3px 0 0;
  border: 1px solid black;
  border-bottom: none;
}

.tinytabs .section {
  background: #f1f1f12e;
  overflow: hidden;
  padding: 15px;
  clear: both;
  border-radius: 3px;
  min-height: 400px;
  border: 1px solid black;
}

.tinytabs .tab.sel {
  background: #f1f1f1;
  color: #333;
  text-shadow: none;
}



.tabs-component-tabs {
  border: solid 1px #504e4e;
  border-radius: 6px;
  margin-bottom: 5px;
}

@media (min-width: 700px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:not(:last-child) {
  border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (min-width: 700px) {
  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #504e4e;
    border-radius: 3px 3px 0 0;
    margin-right: .5em;
    transform: translateY(2px);
    transition: transform .3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    transform: translateY(0);
  }
}

.tabs-component-tab-a {
  align-items: center;
  color: inherit;
  display: flex;
  padding: .75em 1em;
  text-decoration: none;
}

.tabs-component-panels {
  padding: 1em 0;
}

@media (min-width: 700px) {
  .tabs-component-panels {
    border-top-left-radius: 0;
    background-color: #fff;
    border: solid 1px #504e4e;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .05);
    padding: 1em 1em
  }
}

.invoice-item-list .table {
  margin-bottom: 0;
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.invoice-item-list table {
  border-collapse: collapse;
}

.invoice-item-list table thead tr {
  text-transform: uppercase;
  padding: 0.8rem 0;
  font-weight: 700;
  border-top: 1px solid;
  border-bottom: 1px solid;
  font-size: 1rem;
}

.invoice-item-list .table th.invoice-detail-margin {
  width: 8px;
  max-width: 8px;
}

.invoice-item-list .table td,
.invoice-item-list .table th {
  padding: 0.25rem;
}

.invoice-item-list .table td,
.invoice-item-list .table th {
  text-align: left;
  vertical-align: top;
}

.invoice-item-list .table th {
  padding: 0.7rem 0.5rem;
  border: none;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
}

.invoice-item-list .table th {
  text-align: right;
  vertical-align: top;
  background: rgba(49, 130, 206, .31);
}

.invoice-item-list .table td.item-row-summary,
.invoice-item-list .table th.invoice-detail-summary {
  text-align: left;
  width: 50%;
}

.invoice-item-list .table td,
.invoice-item-list .table th {
  text-align: left;
  vertical-align: top;
}

.invoice-items tr {
  border-bottom: 1px dashed #7b7878;
}

.item-row {
  transition: transform .5s ease-out;
}

.item-row .item-row-actions {
  width: 50px;
}

.item-row .item-row-actions .btn {
  min-width: 35px;
  padding: 4px;
}

.item-row .btn {
  -webkit-font-smoothing: antialiased;
  font-weight: 500;
  color: #555;
  background: #f4f4f4;
  background: linear-gradient(#f4f4f4, #e4e4e4);
  border-radius: 3px;
  border: 1px solid #999;
  display: inline-block;
  padding: 4px;
  overflow: hidden;
  text-decoration: none;
  min-width: 34px;
  cursor: pointer;
  transition: .1s ease-in;
  font-size: inherit;
}

.svg-inline--fa.fa-w-11 {
  width: 0.6875em;
}

.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}

.item-row-name {
  display: block;
}

.invoice-items tr.item-row-n {
  border: none;
}

.item-row {
  transition: transform .5s ease-out;
}

.invoice-item-list .table td,
.invoice-item-list .table th {
  padding: 0.25rem;
}

.item-row .item-row-actions {
  width: 50px;
}

.item-row .btn.btn-prime {
  background: #444;
  background: linear-gradient(#555, #444);
  color: #fff;
  font-weight: 500;
}

.item-row .item-row-actions .btn {
  min-width: 35px;
  padding: 4px;
}

.item-row .btn {
  -webkit-font-smoothing: antialiased;
  font-weight: 500;
  color: #555;
  background: #f4f4f4;
  background: linear-gradient(#f4f4f4, #e4e4e4);
  border-radius: 3px;
  border: 1px solid #999;
  display: inline-block;
  padding: 4px;
  overflow: hidden;
  text-decoration: none;
  min-width: 30px;
  cursor: pointer;
  transition: .1s ease-in;
  font-size: inherit;
}

.variantes {
  text-align: center;
  border-top: 2px solid black;
}

.btn-whats {
  position: absolute;
  cursor: pointer;

}

.btn-whats img {
  height: 24px;
  width: 24px;
}

.btn-whats-order {
    top: -12px;
    right: -8px;
}

.btn-whats-ship {
  top: -12px;
  right: -20px;
}
</style>
